import React from 'react';
import Draggable from '../Draggable/Draggable';

export default class TableElement extends React.Component {
    
    renderTable() {
        const {context} = this.props;
        const {properties} = context;
        const {TableData, BorderColor, BorderWidth, BorderStyle} = properties;
        
        // Handle empty or undefined TableData
        if (!TableData || TableData.length === 0) {
            return (
                <div style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: `${BorderWidth || 1}px solid ${BorderColor || '#000000'}`,
                    color: '#999'
                }}>
                    Table
                </div>
            );
        }
        
        return (
            <table style={{
                border: `${BorderWidth}px ${BorderStyle} ${BorderColor}`,
                borderCollapse: 'collapse',
                width: '100%',
                height: '100%',
                tableLayout: 'fixed'
            }}>
                <tbody>
                    {TableData.map((row, rowIndex) => (
                        <tr key={rowIndex} style={{
                            height: row.height || properties.RowHeight || 25,
                            backgroundColor: this.getRowBackground(row, rowIndex)
                        }}>
                            {row.Cells && row.Cells.map((cell, cellIndex) => {
                                const isImageCell = cell.IsImage || cell.isImage;
                                return (
                                    <td 
                                        key={cellIndex}
                                        colSpan={cell.span || 1}
                                        style={{
                                            border: `1px solid ${BorderColor}`,
                                            padding: '4px',
                                            backgroundColor: cell.bg || 'transparent',
                                            color: cell.c || '#000000',
                                            textAlign: cell.align || 'left',
                                            width: cell.w,
                                            height: cell.h,
                                            fontWeight: cell.bold ? 'bold' : 'normal',
                                            fontSize: (cell.fontSize || 12) + 'px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                        onClick={(e) => this.onCellClick(e, rowIndex, cellIndex)}
                                        onDoubleClick={(e) => this.onCellDoubleClick(e, rowIndex, cellIndex)}
                                    >
                                        {isImageCell ? (
                                            <span style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '100%',
                                                height: '100%',
                                                minHeight: 16,
                                                border: '1px dashed #999',
                                                color: '#666',
                                                fontSize: 10
                                            }}>
                                                {cell.v || cell.DataFieldName || 'Image'}
                                            </span>
                                        ) : (cell.v || '')}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
    
    getRowBackground(row, rowIndex) {
        const {properties} = this.props.context;
        
        if (row.isHeader) {
            return '#f0f0f0';
        }
        
        if (properties.ZebraStripe && rowIndex % 2 === 0) {
            return properties.AlternateColor || '#f5f5f5';
        }
        
        return 'transparent';
    }
    
    onCellClick = (e, rowIndex, cellIndex) => {
        // Cell selection logic
        console.log(`Cell clicked: [${rowIndex}][${cellIndex}]`);
        // Don't stop propagation - let it bubble to Draggable
    }
    
    onCellDoubleClick = (e, rowIndex, cellIndex) => {
        // Cell edit mode - for future implementation
        console.log(`Cell edit: [${rowIndex}][${cellIndex}]`);
        // Don't stop propagation - let it bubble to Draggable for properties modal
    }
    
    render() {
        const {context, id, onMouseDown, RemoveIconScale, GridSize, OpenProperties} = this.props;
        const {properties, type} = context;
        
        return (
            <Draggable
                id={id}
                type={type}
                properties={properties}
                onMouseDown={onMouseDown}
                RemoveIconScale={RemoveIconScale}
                GridSize={GridSize}
                OpenProperties={OpenProperties}
                style={{
                    zIndex: properties.Zindex
                }}
            >
                {this.renderTable()}
            </Draggable>
        );
    }
}
